<template>
  <section class="page-container">
    <p class="page-title">CS Home</p>

    <!-- ticket -->
    <div class="box">
      <div
        class="header"
        @click="clickHeader('ticket')">
        <span>
          My Unresolved Tickets
          <font-awesome-icon
            icon="angle-right"
            class="icon"></font-awesome-icon>
        </span>
      </div>
      <ticket-table
        :showHeader="false"
        csHome
        :size="5"></ticket-table>
    </div>

    <!-- policy -->
    <div class="box">
      <div
        class="header"
        @click="clickHeader('policy')">
        <span>
          Policies Need Follow Up
          <font-awesome-icon
            icon="angle-right"
            class="icon"></font-awesome-icon>
        </span>
      </div>
      <policy-table
        :showHeader="false"
        :filters="policyFilters"
        csHome
        :size="5"></policy-table>
    </div>

    <!-- customer -->
    <div class="box">
      <div
        class="header"
        @click="clickHeader('customer')">
        <span>
          Customers Pending Verification
          <font-awesome-icon
            icon="angle-right"
            class="icon"></font-awesome-icon>
        </span>
      </div>
      <div class="customer">
        <el-table
          :show-header="false"
          :data="customerTableData"
          :header-row-class-name="'tableHeader'"
          style="width: 100%"
          :row-class-name="'pointer'"
          @row-click="rowClick"
        >
          <el-table-column
            prop="id"
            width="69"
            align="center"
          >
            <template #default="{ row }">
              <div class="flex-column  flex-align-center">
                <span
                  v-if="row.merchant_platform"
                  class="table-icon__img mg-b-8">
                  <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
                </span>
                <font-awesome-icon icon="user"></font-awesome-icon>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Type"
            width="100">
            <template slot-scope="scope">
              <div class="flex-align">
                <p>
                  <span  class="span-status type-status">{{ scope.row.identity_language }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="isrd_nm"
            :show-overflow-tooltip="true"
            label="Name">
            <template #default="{ row }">
              <div>
                <span
                  v-if="row.is_top_data"
                  class="green_tip block">Potential Match</span>
                <span
                  v-if="row.is_green_tip"
                  class="green_tip">{{row.green_tip}}</span>
                <router-link
                  :to="rowClickFn(row)"
                  class="showLick"
                  :class="{'unname' : row.isrd_nm == ' '}">
                  {{ row.isrd_nm != ' '? row.isrd_nm : 'Unnamed Account'}}
                </router-link>
                <p class="liter-text">#{{ row.id }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="registered_login"
            label="Registered Login & Contact"
          >
            <template slot-scope="scope">
              <span
                class="login-text"
                :class="{'color-purple':scope.row.attached_account}">{{ scope.row.registered_login }}</span>
              <p
                v-if="scope.row.identity==2"
                class="liter-text">{{ scope.row.contact_nm }} {{ scope.row.contact_phone}} {{scope.row.contact_email}}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="policy_num"
            label="Policies"
            width="75"
          ></el-table-column>
          <el-table-column
            label="Status & Tags"
            width="140"
          >
            <template #default="{ row }">
              <div class="flex">
                <span
                  class="span-status"
                  :class="{
                    'success': row.status == 1,
                    'warning': row.status == 2,
                    'error': row.status == 0
                  }">{{ row.status_language }}</span>
              </div>

              <div class="flex tags">
                <span
                  v-if="row.verify_language"
                  class="span-status"
                  :class="{
                    'verified': row.verified == 20,
                    'pending_verify ': row.verified == -1,
                    'not_verify': row.verified == -2
                  }">{{ row.verify_language }}</span>
              </div>
            </template>

          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- quote -->
    <div class="box">
      <div
        class="header"
        @click="clickHeader('quote')">
        <span>
          Unsigned Quotes
          <font-awesome-icon
            icon="angle-right"
            class="icon"></font-awesome-icon>
        </span>
      </div>
      <quote-table
        :showHeader="false"
        :filters="quoteFilters"
        csHome
        :size="5"></quote-table>
    </div>
  </section>
</template>

<script>
import TicketTable from '@/views/components/ticket-table'
import PolicyTable from '@/views/components/policy-table'
import QuoteTable from '@/views/components/quote-table'
import {getCustomerList} from '@/api/account'
import {mapActions} from 'vuex'

export default {
  name: 'CSHOME',
  components:{
    TicketTable,
    PolicyTable,
    QuoteTable,
  },
  data () {
    return {
      customerTableData: [],
      policyFilters: {
        stts: [1,2,3]
      },
      customerFilters: {
        verify_type: [-1],
      },
      quoteFilters: {
        stts: [3]
      }
    }
  },
  mounted(){
    this.network().getCustomerList()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    clickHeader(tab) {
      let path = ''
      switch(tab){
        case 'ticket':
          path = '/tickets/list/unresolved'
          break
        case 'policy':
          path = '/records/policy'
          this.setFilterData({policy: this.policyFilters})
          break
        case 'customer':
          path = '/accounts'
          this.setFilterData({account: this.customerFilters})
          break
        case 'quote':
          path = '/records/quote'
          this.setFilterData({quote: this.quoteFilters})
      }
      this.$router.push({
        path
      })
    },
    rowClick(row) {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: row.id,
        },
      })
    },
    rowClickFn(row) {
      return ({
        path: '/accounts/detail',
        query: {
          customer_id: row.id,
        },
      })
    },
    network() {
      return {
        getCustomerList: async () => {
          let {data} = await getCustomerList({
            verify_type: [-1],
            size: 5
          })
          data.data.map((item, index) => {
            item.checked = false
            item.index = index
            return item
          })
          this.customerTableData = data.data
        },
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  // padding: 0 70px;
  background: #FFFFFF;
  .page-title{
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    height: 36px;
  }
  .box{
    font-family: inter;
    margin: auto;
    margin-top: 30px;
    border-radius: 6px;
    width: 1000px;
    .header{
      background: #F6F8FA;
      border: 1px solid #E1E4E8;
      border-bottom: none;
      border-radius: 6px 6px 0px 0px;
      font-weight: 600;
      font-size: 14px;
      color: #0366D6;
      height: 52px;
      display: flex;
      align-items: center;
      padding: 16px;
      cursor: pointer;
      span{
        height: 20px;
        display: flex;
        align-items: center;
      }
      .icon{
        margin-left: 6px;
      }
    }
    /deep/ .el-table{
      border: 1px solid #E1E4E8;
      border-radius: 0;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      box-sizing: content-box;
    }
    .customer{
      .span-status {
        display: block;
        margin-right: 5px;
        padding: 0 10px;
        height:  20px;
        line-height: 20px;
        border-radius: 25px;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        &.success {
          color: #22863A;
          background: #DCFFE4;
        }
        &.warning {
          background: #FFF5B1;
          color: #B08800;
        }
        &.error {
          background: #D73A49;
          color: white;
        }
        &.warning-plain {
          padding: 0 8px;
          font-size: 12px;
          color: #735C0F;
          background: #FFFFFF;
          border: 1px solid #B08800;
          border-radius: 100px;
          line-height: 20px;
          white-space: nowrap;
        }
        &.unread-uplod {
          padding: 0 8px;
          font-size: 12px;
          background: #FFFFFF;
          border: 1px solid #F66A0A;
          border-radius: 100px;
          line-height: 20px;
          white-space: nowrap;
          color: #C24E00;
        }
        &.diamond-status{
          padding: 0 8px;
          font-size: 12px;
          background: #FFFFFF;
          border-radius: 100px;
          line-height: 20px;
          white-space: nowrap;
          border: 1px solid #0366D6;
          color: #0366D6;
        }
        &.verified{
          padding: 0 8px;
          font-size: 12px;
          background: #FFFFFF;
          border-radius: 100px;
          line-height: 20px;
          white-space: nowrap;
          border: 1px solid #22863a;
          color: #22863a;
        }
        &.pending_verify{
          padding: 0 8px;
          font-size: 12px;
          background: #FFFFFF;
          border-radius: 100px;
          line-height: 20px;
          white-space: nowrap;
          border: 1px solid #dbab09;
          color: #dbab09;
        }
        &.not_verify{
          padding: 0 8px;
          font-size: 12px;
          background: #FFFFFF;
          border-radius: 100px;
          line-height: 20px;
          white-space: nowrap;
          border: 1px solid #d73a49;
          color: #d73a49;
        }
        &.type-status{
          border: 1px solid #6A737D;
          border-radius: 100px;
          color: #24292E;
          padding: 0 8px;
          text-align: center;
          flex: 1
        }
      }
      /deep/ .el-table{
        border-radius: 4px;
        border: 1px solid #E1E4E8;
        tr{
          td{
            padding: 10px 15px 10px 0!important;
            vertical-align: top;
            margin-right: 15px;
            .cell{
              line-height: 23px;
              position: relative;
              height: inherit;
              padding: 0;
            }
          }
        }
        .table-pointer{
          cursor: pointer;
        }
      }
      ::v-deep .tableHeader {
        margin-top: 30px;
        background: #F6F8FA !important;
        border-bottom: 1px solid #E1E4E8;
        th {
          background-color: #F6F8FA !important;
          font-family: Inter;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          letter-spacing: -0.15px;
          /* Text/text-gray-dark */

          color: #24292E;
        }
      }
      .flex-align{
        align-items: center;
        p{
          height: 24px;
          display: flex;
          align-items: center;
        }
      }
      .el-table{
        p:first-child{
          color: #24292E;
          font-size: 14px;
          font-weight: 500;
        }
        .login-text{
          color: #24292E;
          font-family: Inter;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 17px;
        }
        .liter-text{
          color: #6A737D;
          font-family: Inter;
          font-size: 12px;
          letter-spacing: 0;
          line-height: 15px;
        }
        .tags{
          margin-top: 2px;
        }
      }
      .showLick{
        color:  #000;
        text-decoration: none;
        font-weight: 600;
        &:hover{
          color:  #0366D6;
        }
      }
      .unname{
        font-style: italic;
        color: #6A737D;
      }
    }
  }
}
</style>
